// src/components/Footer.tsx
import React, { useState } from "react";
import { Layout, Button, Modal, Col, Row } from "antd";
import { InstagramOutlined, PinterestOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import FAQs from "./FAQs";
import SubscribeForm from "../components-reusable/SubscribeForm";

const { Footer } = Layout;

const FooterComponent: React.FC = () => {
  const [visible, setVisible] = useState(false);

  const handleFAQ = () => {
    setVisible(true);
  };

  const handleClose = () => {
    setVisible(false);
  };

  return (
    <Footer
      style={{
        textAlign: "center",
        justifyContent: "space-between",
        background: "white",
        marginTop:"10px"
      }}
    >
      <SubscribeForm caller={"footer"} />

      <div style={{ margin: "20px" }}>
        <Button type="link" onClick={handleFAQ} style={{ fontSize: 30 }}>
          FAQ
        </Button>
        <Modal
          title="Frequently Asked Questions"
          open={visible}
          onCancel={handleClose}
          footer={null}
        >
          <FAQs modal={true} />
        </Modal>
      </div>
      <Row gutter={16} justify="center">
        <Col>
          <Link
            to="https://www.instagram.com/alamodeimage/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <InstagramOutlined style={{ fontSize: "24px", color: "#e4405f" }} />
          </Link>
        </Col>
        <Col>
          <Link
            to="https://www.pinterest.com/alamodeimage/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <PinterestOutlined style={{ fontSize: "24px", color: "#0077b5" }} />
          </Link>
        </Col>
      </Row>
      <Row gutter={16} justify={"center"} style={{ paddingTop: "20px" }}>
        © {new Date().getFullYear()} Alamode Image. All rights reserved.
      </Row>
    </Footer>
  );
};

export default FooterComponent;
